export default {
  "Loop as a GIF": "تكرار كملف GIF",
  "without sound": "بدون صوت",
  "Final output duration": "مدة الإخراج النهائية",
};
